import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import t from "../core/Plugin";

var e = /*#__PURE__*/function (_t) {
  _inherits(e, _t);

  var _super = _createSuper(e);

  function e(t) {
    var _this;

    _classCallCheck(this, e);

    _this = _super.call(this, t);
    _this.isFormValid = false;
    _this.opts = Object.assign({}, {
      aspNetButton: false,
      buttons: function buttons(t) {
        return [].slice.call(t.querySelectorAll('[type="submit"]:not([formnovalidate])'));
      }
    }, t);
    _this.submitHandler = _this.handleSubmitEvent.bind(_assertThisInitialized(_this));
    _this.buttonClickHandler = _this.handleClickEvent.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(e, [{
    key: "install",
    value: function install() {
      var _this2 = this;

      if (!(this.core.getFormElement() instanceof HTMLFormElement)) {
        return;
      }

      var t = this.core.getFormElement();
      this.submitButtons = this.opts.buttons(t);
      t.setAttribute("novalidate", "novalidate");
      t.addEventListener("submit", this.submitHandler);
      this.hiddenClickedEle = document.createElement("input");
      this.hiddenClickedEle.setAttribute("type", "hidden");
      t.appendChild(this.hiddenClickedEle);
      this.submitButtons.forEach(function (t) {
        t.addEventListener("click", _this2.buttonClickHandler);
      });
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      var _this3 = this;

      var t = this.core.getFormElement();

      if (t instanceof HTMLFormElement) {
        t.removeEventListener("submit", this.submitHandler);
      }

      this.submitButtons.forEach(function (t) {
        t.removeEventListener("click", _this3.buttonClickHandler);
      });
      this.hiddenClickedEle.parentElement.removeChild(this.hiddenClickedEle);
    }
  }, {
    key: "handleSubmitEvent",
    value: function handleSubmitEvent(t) {
      this.validateForm(t);
    }
  }, {
    key: "handleClickEvent",
    value: function handleClickEvent(t) {
      var _e = t.currentTarget;

      if (_e instanceof HTMLElement) {
        if (this.opts.aspNetButton && this.isFormValid === true) {} else {
          var _e3 = this.core.getFormElement();

          _e3.removeEventListener("submit", this.submitHandler);

          this.clickedButton = t.target;
          var i = this.clickedButton.getAttribute("name");
          var s = this.clickedButton.getAttribute("value");

          if (i && s) {
            this.hiddenClickedEle.setAttribute("name", i);
            this.hiddenClickedEle.setAttribute("value", s);
          }

          this.validateForm(t);
        }
      }
    }
  }, {
    key: "validateForm",
    value: function validateForm(t) {
      var _this4 = this;

      t.preventDefault();
      this.core.validate().then(function (t) {
        if (t === "Valid" && _this4.opts.aspNetButton && !_this4.isFormValid && _this4.clickedButton) {
          _this4.isFormValid = true;

          _this4.clickedButton.removeEventListener("click", _this4.buttonClickHandler);

          _this4.clickedButton.click();
        }
      });
    }
  }]);

  return e;
}(t);

export { e as default };